import { forwardRef, MutableRefObject } from "react";
import ReactQuill from "react-quill";

interface IProps {
  uploadRequest?: (file: File) => Promise<any>;
  quillRef: MutableRefObject<ReactQuill | null>;
}

export const WysiwigImage = forwardRef<HTMLInputElement, IProps>(({ quillRef, uploadRequest }, ref) => {
  const handleChange = async (file: File) => {
    if (!quillRef.current) {
      return;
    }
    const fileUrl = uploadRequest ? await uploadRequest(file) : null;
    const quillEditor = quillRef.current.getEditor();
    const rangeIndex = quillEditor.getSelection()?.index || 0;
    if (uploadRequest) {
      quillEditor.insertEmbed(rangeIndex, "image", fileUrl);
    }
  };

  const InputImage = ({ beforeUpload }: { beforeUpload: (file: File) => void }) => (
    <input
      ref={ref}
      type="file"
      accept="image/*"
      style={{ display: "none" }}
      onChange={async ({ currentTarget }) => {
        const file = currentTarget.files?.[0];
        file && beforeUpload(file);
      }}
    />
  );

  return <InputImage beforeUpload={handleChange} />;
});
